import { render, staticRenderFns } from "./mgFormItem.vue?vue&type=template&id=cab3b514&scoped=true&"
import script from "./mgFormItem.vue?vue&type=script&lang=js&"
export * from "./mgFormItem.vue?vue&type=script&lang=js&"
import style0 from "./mgFormItem.vue?vue&type=style&index=0&id=cab3b514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab3b514",
  null
  
)

export default component.exports